<template lang="pug">
div.padding.p-b-0.p-t-md
    div.row
        div.col-md-4
            div.m-b-sm
                h5.m-b-0.p-t-sm._300 Inventory

        div.col-md-8
            div.col-sm-4.m-y-sm.p-r-0.pull-right
                outlet-selector

            div.col-sm-4.m-y-sm.p-r-0.pull-right
                select.form-control.c-select(v-model="level")
                    option(:value="null") Filter Stock Level
                    option(value="low") Low Level
                    option(value="normal") Normal Level
                    option(value="ideal") Ideal Level

    div.row
        div.col-md-12
            div.box
                v-server-table(
                    :url="api",
                    :name="tableName",
                    ref="datatable",
                    :columns="columns",
                    :options="options"
                )
                    template(slot="afterTable")
                        .block.text-center.p-a
                            span.p-a-xs.low-level.m-r-sm Low Level
                            span.p-a-xs.normal-level.m-r-sm Normal Level
                            span.p-a-xs.ideal-level Ideal Level
</template>

<script>
const exportRoute = 'stocks.inventories.export';

export default {
    data() {
        var that = this;

        return {
            tableName: 'VUETABLE_STOCK',
            level: null,
            columns: [
                'name',
                'sku',
                'barcode',
                'price',
                'quantity',
                'low_stock_level',
                'ideal_stock_level',
                'outlet',
            ],
            options: {
                useReportFilter: true,
                customFilters: ['level'],
                texts: {
                    title: 'Stock Inventory',
                    description: 'List of inventory items by outlet',
                },
                pdf_url: Laroute.route(exportRoute, { type: 'PDF' }),
                csv_url: Laroute.route(exportRoute, { type: 'CSV' }),
                xls_url: Laroute.route(exportRoute, { type: 'XLSX' }),
                actionButtons: [
                    {
                        title: 'Import',
                        action: () => {
                            this.$router.push(`/import`);
                        },
                    },
                ],
                rowClassCallback(row) {
                    const qty = parseFloat(row.quantity);
                    const lowStock = parseFloat(row.low_stock_level);
                    const idealStock = parseFloat(row.ideal_stock_level);

                    if (qty <= lowStock) {
                        return 'inventory-low';
                    }

                    if (qty >= idealStock && idealStock > 0) {
                        return 'inventory-ideal';
                    }

                    return 'inventory-normal';
                },
                columnsClasses: {
                    quantity: 'quantity text-center',
                    low_stock_level: 'text-center',
                    ideal_stock_level: 'text-center',
                },
                skin: 'table m-b-0 b-b',
                templates: {
                    quantity(h, row) {
                        return require('./inventory-quantity.jsx')(h, row);
                    },
                },
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('stocks.inventories.index');
        },
    },

    watch: {
        level(level) {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'level',
                value: level,
            });
        },
    },
};
</script>

<style lang="scss">
$low-level: #ffecec;
$ideal-level: #f7ffed;
$normal-level: #f2fdff;

.normal-level {
    background: $normal-level;
}

.ideal-level {
    background: $ideal-level;
}

.low-level {
    background: $low-level;
}

.inventory-low {
    .quantity {
        background: $low-level;
    }
}

.inventory-ideal {
    .quantity {
        background: $ideal-level;
    }
}

.inventory-normal {
    .quantity {
        background: $normal-level;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/stock/stock-inventory-list.vue